// extracted by mini-css-extract-plugin
export var outterContainer = "styles-module--outterContainer--0AlaZ";